// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'react-feather';
import ReactPaginate from 'react-paginate';

// import utility file
import { Avatar } from '../../../elements/bootstrap/Avatar';
import LivreService from '../../services/LivreService';

// import utility file

const LivresGridCard = () => {
	const [originallivre, setOriginalLivre] = useState([]);
	const [livres, setLivres] = useState([]);

	// Functions for display formatting
	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'titre' && value) {
				return value.toUpperCase();
			} else if (columnId === 'editeur' || columnId === 'date_achat') {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else {
				return value;
			}
		}
		return value;
	};

	const getInitials = (livre) => {
		const auteur = livre.auteur
			? livre.auteur.charAt(0).toUpperCase()
			: '';
		const titre = livre.titre ? livre.titre.charAt(0).toUpperCase() : '';
		return `${titre} ${auteur}`;
	};

	useEffect(() => {
		Promise.all([LivreService.getAllLivres()]).then(([livresData]) => {
			setOriginalLivre(livresData);
			setLivres(livresData);
		});
	}, []);

	// searching code started
	const [searchTerm, setSearchTerm] = useState('');

	const getSearchTerm = (event) => {
		let searchTerm = event.target.value;
		setSearchTerm(searchTerm);
		if (searchTerm !== '') {
			const newLivresList = originallivre.filter((livre) => {
				let livreData =
					`${livre.titre} ${livre.auteur} ${livre.editeur} ${livre.date_achat} ${livre.numero_appel}`.toLowerCase();
				return livreData.includes(searchTerm.toLowerCase());
			});
			setLivres(newLivresList);
			setPageNumber(0);
		} else {
			setLivres(originallivre);
		}
	};

	const livresEleve = livres.map((livre) => ({
		...livre
	}));

	// paging start
	const [pageNumber, setPageNumber] = useState(0);
	const livresPerPage = 8;
	const pagesVisited = pageNumber * livresPerPage;
	const pageCount = Math.ceil(livresEleve.length / livresPerPage);
	const changePage = ({ selected }) => {
		setPageNumber(selected);
	};

	const displayLivres = livresEleve
		.slice(pagesVisited, pagesVisited + livresPerPage)
		.map((livre) => {
			const initials = getInitials(livre);
			return (
				<Col xl={3} lg={6} md={6} sm={12} key={livre.id}>
					<Card className="mb-5">
						<Card.Body>
							<div className="text-center">
								<div className="position-relative mb-2">
									<Link to={`/services/bibliotheque/catalogue/${livre.id}`}>
										<Avatar
											type="initial"
											size="xl"
											name={initials}
											className="rounded-circle"
											alt={initials}
										/>
									</Link>
								</div>
								<Link to={`/services/bibliotheque/catalogue/${livre.id}`}>
									<h4 className="mb-0">{formatValue(livre.titre, 'titre')}</h4>
								</Link>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2 mt-6">
								<span>Auteur</span>
								<span className="text-dark">
									{formatValue(livre.auteur, 'auteur')}
								</span>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2">
								<span>Numero d'appel</span>
								<span>{livre.numero_appel}</span>
							</div>
							<div className="d-flex justify-content-between pt-2">
								<span>Date d'achat</span>
								<span className="text-dark">
									{formatValue(livre.date_achat, 'date_achat')}
								</span>
							</div>
						</Card.Body>
					</Card>
				</Col>
			);
		});
	// end of paging

	return (
		<Fragment>
			<div className="mb-4">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xl={2} lg={4} md={6} xs={12}>
						{/* search records */}
						<div className="mb-2 mb-lg-4">
							<Form.Control
								type="search"
								placeholder="Rechercher un livre"
								value={searchTerm}
								onChange={getSearchTerm}
							/>
						</div>
					</Col>
				</Row>
			</div>
			<Row>
				{displayLivres.length > 0 ? (
					displayLivres
				) : (
					<Col>Aucun livre correspondant n'a été trouvé.</Col>
				)}
			</Row>
			<ReactPaginate
				previousLabel={<ChevronLeft size="14px" />}
				nextLabel={<ChevronRight size="14px" />}
				pageCount={pageCount}
				onPageChange={changePage}
				containerClassName={'justify-content-center mb-0 pagination'}
				previousLinkClassName={'page-link mx-1 rounded'}
				nextLinkClassName={'page-link mx-1 rounded'}
				pageClassName={'page-item'}
				pageLinkClassName={'page-link mx-1 rounded'}
				disabledClassName={'paginationDisabled'}
				activeClassName={'active'}
			/>
		</Fragment>
	);
};

export default LivresGridCard;
